import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

import "yet-another-react-lightbox/styles.css";

import '@fortawesome/fontawesome-free/css/all.min.css';

import './index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
